import { UtilityType } from 'switch-shared/modules/crud/utility/utility.enums';
import { BILLING_TYPE } from 'switch-shared/types/general.enums';
import { Parameter } from 'switch-shared/types/parameter.enums';

export const getBillingColor = (billingType: BILLING_TYPE) => {
  switch (billingType) {
    case BILLING_TYPE.PREPAID:
      return '#0e924f';
    case BILLING_TYPE.POSTPAID:
      return '#fe9a00';
    default:
      return '#808080';
  }
};

export const bulkColors = {
  BULK_COLOR: '#AADABF',
  TENANT_COLOR: '#D1D04D',
  COMMUNAL_COLOR: '#557091',
};

export const powerColors = {
  [Parameter.PMD]: '#FF6B6B',
  [Parameter.QMD]: '#5AC8FA',
  [Parameter.SMD]: '#BF5AF2',
};

export const lineColors = {
  L1: '#e60b0f',
  L2: '#e6e51e',
  L3: '#2c77b1',
  totalImport: '#9b59b6',
  totalExport: '#1abc9c',
};

export const utilityColorsRGB = {
  [UtilityType.WATER]: {
    r: 0,
    g: 125,
    b: 255,
  },
  [UtilityType.ELECTRICITY]: {
    r: 255,
    g: 223,
    b: 0,
  },
  [UtilityType.FIXED_FEE]: {
    r: 0,
    g: 159,
    b: 63,
  },
  [UtilityType.GAS]: {
    r: 191,
    g: 0,
    b: 255,
  },
};

export const utilityColors = {
  water: {
    import: {
      stroke: '#2196f3',
      fill: 'rgba(38, 175, 237, 0.4)',
    },
    export: {
      stroke: '#2156a3',
      fill: 'rgba(38, 75, 137, 0.4)',
    },
  },
  electricity: {
    import: {
      stroke: '#ffdb3b',
      fill: 'rgba(255, 235, 59,0.3)',
    },
    export: {
      stroke: 'rgba(205, 105, 0)',
      fill: 'rgba(255, 105, 0,0.3)',
    },
  },
  fixedFee: {
    import: {
      stroke: '#1fcc00',
      fill: 'rgba(23, 153, 0, 0.4)',
    },
    export: {
      stroke: '#1fcc00',
      fill: 'rgba(23, 153, 0, 0.4)',
    },
  },
  gas: {
    import: {
      stroke: '#6a1b9a',
      fill: '#e1bee7',
    },
    export: {
      stroke: '#6a1b9a',
      fill: '#e1bee7',
    },
  },
  default: {
    import: {
      stroke: '#1fcc00',
      fill: 'rgba(23, 153, 0, 0.4)',
    },
    export: {
      stroke: '#1fcc00',
      fill: 'rgba(23, 153, 0, 0.4)',
    },
  },
};

export const getUtilityColor = (utility: UtilityType) => {
  switch (utility) {
    case UtilityType.WATER:
      return utilityColors.water;
    case UtilityType.ELECTRICITY:
      return utilityColors.electricity;
    case UtilityType.FIXED_FEE:
      return utilityColors.fixedFee;
    case UtilityType.GAS:
      return utilityColors.gas;
    default:
      return utilityColors.default;
  }
};
